import getCookie from '@helpers/getCookie.js';
import setCookie from '@helpers/setCookie.js';

(function () {
  const $els = document.querySelectorAll('[data-vue=cookieAlert]');

  if (!$els.length) {
    return;
  }

  if (getCookie('acceptCookie')) {
    document.body.classList.add('cookie-alert-show');
    return;
  }

  new Vue({
    el: '[data-vue=cookieAlert]',
    data: {},
    methods: {
      acceptCookie (param) {
        if (param == false) {
          document.cookie.split(';').forEach(function (c) {
            document.cookie = c
              .replace(/^ +/, '')
              .replace(
                /=.*/,
                '=;expires=' + new Date().toUTCString() + ';path=/'
              );
          });
          window.location.href = 'https://www.google.com.br/';
        }

        if (param == true) {
          document.body.classList.add('cookie-alert-show');
          if (!getCookie('acceptCookie')) {
            setCookie('acceptCookie', param, 365);
          }
        }
      }
    },
    created: function () {
      if (!getCookie('acceptCookie')) {
        setCookie('acceptCookie', false);
      }
    }
  });
})();
